import React from "react";
import Skeleton from "@material-ui/lab/Skeleton/Skeleton";

export const AvatarSkeleton = (props) => (
    <div>
        <Skeleton  variant="circle" height={props.size ? props.size : 200} width={props.size ? props.size : 200}  style={{transform: "translateX(50%)",marginRight:"50%"}}/>
    </div>
)